import Anna from '../../../../assets/images/Campaign/Colour/Anna/anna_video.jpg';
import Mack from '../../../../assets/images/Campaign/Colour/Mack/mack_video.jpg';
import Dina from '../../../../assets/images/Campaign/Colour/Dina/dina_video.jpg';
import Payal from '../../../../assets/images/Campaign/Colour/Payal/payal_video.jpg';
import Acton from '../../../../assets/images/Campaign/Colour/Acton/acton_video.png';
import Aleksandra from '../../../../assets/images/Campaign/Colour/Aleksandra/aleks_video.png';
import Ziggy from '../../../../assets/images/Campaign/Colour/Ziggy/ziggy_video.jpg';
import Sonia from '../../../../assets/images/Campaign/Colour/Sonia/sonia_video.jpg';

import { ColourTheme } from '../../../../types/ColourTheme';

export const personaToVidImg: Record<ColourTheme, string> = {
  [ColourTheme.cerulean]: Anna,
  [ColourTheme.skyblue]: Mack,
  [ColourTheme.pomegranate]: Dina,
  [ColourTheme.orchidpink]: Payal,
  [ColourTheme.greensea]: Acton,
  [ColourTheme.jade]: Aleksandra,
  [ColourTheme.carrot]: Ziggy,
  [ColourTheme.sunflower]: Sonia,
  [ColourTheme.default]: Anna,
};

export const personaToVidLink: Record<ColourTheme, string> = {
  [ColourTheme.cerulean]: 'rPBHGwB9s-c',
  [ColourTheme.skyblue]: '2M3z6rgFRaw',
  [ColourTheme.pomegranate]: 'lESvZFIIkwc',
  [ColourTheme.orchidpink]: 'f4kx5qRiCAk',
  [ColourTheme.greensea]: 'ombpzR4s4rs',
  [ColourTheme.jade]: 'IwLyi86ziv4',
  [ColourTheme.sunflower]: '2JB7cFak8E8',
  [ColourTheme.carrot]: 'yaNed9Fj_WQ',
  [ColourTheme.default]: 'rPBHGwB9s-c',
};
